import { render, staticRenderFns } from "./themactdetail.vue?vue&type=template&id=1dd0b414&scoped=true&"
import script from "./themactdetail.vue?vue&type=script&lang=js&"
export * from "./themactdetail.vue?vue&type=script&lang=js&"
import style0 from "./themactdetail.vue?vue&type=style&index=0&id=1dd0b414&scoped=scoped&lang=scss&"
import style1 from "./themactdetail.vue?vue&type=style&index=1&id=1dd0b414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd0b414",
  null
  
)

export default component.exports